import { Link } from "react-router-dom";
import { useLanguage } from "../context/language";
import { COMPANY } from "../data/company";

export const Footer = () => {
  const { t: e } = useLanguage();
  return (
    <footer className="bg-[#131313] border-t border-gray-800 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.35fr_2fr] lg:gap-16">
          <div className="max-w-md">
            <div className="mb-4">
              <img
                src="/assets/images/actrium_logo.svg"
                alt="Actrium AI"
                className="h-6 filter brightness-0 invert"
              />
            </div>
            <p className="text-[#777] text-base leading-relaxed mb-5">{e.footer.bio}</p>
            <div className="flex space-x-4 -mx-2 -my-2 p-2">
              <a
                href="https://www.youtube.com/@Actrium_AI"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-white/5 hover:rounded-full"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
              <a
                href="https://x.com/ActriumAI"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-white/5 hover:rounded-full"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/actrium-ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-white/5 hover:rounded-full"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                  <rect x="2" y="9" width="4" height="12" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
            {[
              {
                title: "Explore",
                links: [
                  ["Products", "/products"],
                  ["Solutions", "/solutions"],
                  ["Resources", "/resources/integration"],
                ],
              },
              {
                title: "Company",
                links: [
                  ["About", "/about"],
                  ["Careers", "/careers"],
                ],
              },
              {
                title: "Legal",
                links: [
                  ["Privacy Policy", "/privacy"],
                  ["Terms of Service", "/terms"],
                  ["Legal Entity", "/legal-entity"],
                ],
              },
            ].map((t) => (
              <div key={t.title}>
                <div className="text-base leading-normal text-white font-bold mb-4">{t.title}</div>
                <ul className="space-y-2">
                  {t.links.map(([n, r]) => (
                    <li key={r}>
                      <Link to={r} className="text-base text-gray-400 hover:text-white transition-colors">
                        {n}
                      </Link>
                    </li>
                  ))}
                  {t.title === "Company" && (
                    <li>
                      <a
                        href={`mailto:${COMPANY.email}`}
                        className="text-base text-gray-400 hover:text-white"
                      >
                        Contact
                      </a>
                    </li>
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-4 border-t border-gray-800 pt-6 text-base text-gray-500 md:flex-row md:items-center md:justify-between">
          <address className="not-italic leading-snug">
            <span>{COMPANY.legalName}</span>
            <span className="mx-2 hidden text-gray-700 md:inline">|</span>
            <span className="block md:inline">
              {COMPANY.addressLine1}, {COMPANY.addressLine2}
            </span>
          </address>
          <p>{e.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
};
